module.exports = __webpack_public_path__ + "media/svg/hr-77e30da2.svg";